/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getScrapAuthorizations,
    getScrapAuthorization,
    printScrapAuthorization,
    createScrapAuthorizations,
    updateScrapAuthorizations,
    deleteScrapAuthorizations,
} from "Modules/manufacturing/scrap_authorizations/config/api.scrap_authorizations";

const state = {
    page: {},
    form: {},
    scrap_authorizations: [],
    scrap_authorization_options: [],
    selectedScrapAuthorization: {
        scrap_auth_id: null,
        company_id: "",
        scrap_authorization_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        scrap_authorization_details: [],
    },
    scrap_authorizations_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_scrap_authorizations: {
        scrap_auth_id: {
            name: "scrap_auth_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        nonconformance_id: {
            name: "nonconformance_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        corrective_action: {
            name: "corrective_action",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        car_number: {
            name: "car_number",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        part_id: {
            name: "part_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        batch_id: {
            name: "batch_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quality_mgr_id: {
            name: "quality_mgr_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quality_mgr_date: {
            name: "quality_mgr_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        sales_mgr_id: {
            name: "sales_mgr_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        sales_mgr_date: {
            name: "sales_mgr_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        ehs_mgr_id: {
            name: "ehs_mgr_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ehs_mgr_date: {
            name: "ehs_mgr_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        production_mgr_id: {
            name: "production_mgr_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        production_mgr_date: {
            name: "production_mgr_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        executive_id: {
            name: "executive_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        executive_date: {
            name: "executive_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        qty_scrapped: {
            name: "qty_scrapped",
            rules: "trim|max_length[10]|integer|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        rma_number: {
            name: "rma_number",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        part_cost_estimate: {
            name: "part_cost_estimate",
            rules: "trim|max_length[17]|decimal",
            max_len: "16",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    scrap_authorizations: (state) => {
        return state.scrap_authorizations;
    },
};

// actions
const actions = {
    async fetchScrapAuthorizations({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getScrapAuthorizations({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "scrap_authorization_options",
                        with: response.data.scrap_authorization,
                    });
                } else {
                    commit("mutate", {
                        property: "scrap_authorizations",
                        with: response.data.scrap_authorization,
                    });
                }
                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchScrapAuthorization({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getScrapAuthorization(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedScrapAuthorization",
                    with: response.data.scrap_authorization,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printScrapAuthorization({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printScrapAuthorization(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveScrapAuthorization({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["scrap_auth_id"] === "undefined" || body["scrap_auth_id"] == null || body["scrap_auth_id"] == "") {
                delete body["scrap_auth_id"];
                response = await createScrapAuthorizations({ body: body, headers: config.headers });
            } else {
                let scrap_auth_id = body["scrap_auth_id"];
                delete body["scrap_auth_id"];
                response = await updateScrapAuthorizations({ body: body, headers: config.headers }, scrap_auth_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteScrapAuthorization({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteScrapAuthorizations(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
